<template>
  <div>
    <v-progress-linear
      indeterminate
      color="primary darken-2"
      v-if="getLoadingPreview"
    ></v-progress-linear>
    <!--    <ImagesSlider v-if="getEventsDetail.length == 0 && getPreview.length == 0"></ImagesSlider>-->
    <!--    <LiveDetail v-if="getEventsLiveDetail.length > 0"></LiveDetail>-->
    <LiveStream v-if="getStreamLive"></LiveStream>

    <ToolbarSportsTree
      class="mt-3"
      v-if="
        !checkIsMobile() &&
        getGameConsole === 'marketview' &&
        getUseExternalTree === true
      "
      :gameMode="getLiveMode"
    ></ToolbarSportsTree>

    <Top-carousel
      v-if="
        getPreview.length === 0 &&
        getEventsDetail.length === 0 &&
        this.getLiveMode == 'preview'
      "
    ></Top-carousel>

    <SkinToolbarNotificator
      v-if="getGameConsole === 'marketview'"
    ></SkinToolbarNotificator>

    <template v-if="getQbet">
      <QuickBetDeatil></QuickBetDeatil>
    </template>
    <template v-else-if="this.getLiveMode == 'preview'">
      <!-- <LiveWidget v-if="this.getSettings.enableLive && getEventsDetail.length == 0 && getPreview.length == 0"></LiveWidget> -->

      <FeaturedTournamentsWidget
        v-if="
          getFeaturedTournamentWidget === true &&
          getPreview.length === 0 &&
          getEventsDetail.length === 0
        "
      ></FeaturedTournamentsWidget>

      <NextEventsWidget
        key="next_event_preview"
        v-if="
          getGameConsole === 'marketview' &&
          getPreview.length === 0 &&
          getEventsDetail.length === 0
        "
        :limitEvent="5"
        :page="1"
        :closable="false"
        :controlPagination="true"
      ></NextEventsWidget>
      <Detail></Detail>

      <!--      <featured-tournaments v-if="getFeaturedTournamentAutoLoad == true  && getEventsDetail.length == 0 && getPreview.length == 0 && getCountNextEvents.length == 0"></featured-tournaments>-->

      <Preview v-if="getEventsDetail.length == 0"></Preview>

      <!--      <SkinToolbarNotificator v-if="getGameConsole === 'marketview'"></SkinToolbarNotificator>-->

      <ImagesWidget
        v-if="getEventsDetail.length == 0 && getPreview.length == 0"
      ></ImagesWidget>

      <!--      <LiveHomeWidget v-if="getSettings.enableLive && getEventsDetail.length == 0 && getPreview.length == 0"></LiveHomeWidget>-->
      <EventsBestPlayedWidget
        v-if="getPreview.length === 0 && getEventsDetail.length === 0"
      ></EventsBestPlayedWidget>
      <EventsDayWidgetServer v-if="getEventDay"></EventsDayWidgetServer>
      <NextEventsWidget
        v-if="getGameConsole === 'default' && getNextEvent"
      ></NextEventsWidget>
    </template>
    <template
      v-else-if="this.getLiveMode == 'detail' && this.getSettings.enableLive"
    >
      <LivePreview></LivePreview>
    </template>

    <FixedCart></FixedCart>
    <v-snackbar v-model="getSnackbar">
      {{ $t(getSnackbarText) }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red darken-2"
          dark
          text
          v-bind="attrs"
          @click="closeSnackbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>

    <Legend></Legend>
  </div>
</template>

<script>
import LiveWidget from '@/components/center_widgets/LiveWidget'
import LivePreview from '@/components/center_widgets/LivePreview'
import Preview from '@/components/center_widgets/Preview'
import Detail from '@/components/center_widgets/Detail'
import LiveDetail from '@/components/center_widgets/LiveDetail'
import NextEventsWidget from '@/components/center_widgets/NextEventsWidget'
import EventsBestPlayedWidget from '@/components/center_widgets/EventsBestPlayedWidget'
import ImagesWidget from '@/components/center_widgets/ImagesWidget'
import { mapActions, mapGetters } from 'vuex'
import ImagesSlider from '@/components/center_widgets/ImagesSlider'
import QuickBet from '@/components/left_widgets/QuickBet'
import QuickBetDeatil from '@/components/center_widgets/QuickBetDetail'
import FixedCart from '@/components/center_widgets/FixedCart'
import LiveHomeWidget from '@/components/center_widgets/LiveHomeWidget'
import TopCarousel from '@/components/center_widgets/TopCarousel'
import EventsDayWidgetServer from '@/components/center_widgets/EventsDayWidgetServer'
import Legend from './center_widgets/Legend'
import LoadingSkeleton from '@/components/generic/LoadingSkeleton'
import SkinToolbarNotificator from './generic/SkinToolbarNotificator'
import findLodash from 'lodash/find'
import ToolbarSportsTree from '@/components/center_widgets/ToolbarSportsTree.vue'
import { checkIsMobileDevice } from '@/plugins/device-inspector'

// import _ from "lodash";

const LiveStream = () => ({
  component: import('@/components/center_widgets/LiveStream'),
  loading: LoadingSkeleton,
  timeout: 200,
})

// const FeaturedTournaments = () => ({
//   component: import('@/components/center_widgets/FeaturedTournaments'),
//   loading: LoadingSkeleton,
//   timeout: 200
// })

const FeaturedTournamentsWidget = () => ({
  component: import('@/components/center_widgets/FeaturedTournamentsWidget'),
  loading: LoadingSkeleton,
  timeout: 200,
})

export default {
  name: 'Center',
  components: {
    ToolbarSportsTree,
    SkinToolbarNotificator,
    FeaturedTournamentsWidget,
    EventsBestPlayedWidget,
    Legend,
    TopCarousel,
    LiveHomeWidget,
    FixedCart,
    QuickBetDeatil,
    QuickBet,
    LiveStream,
    ImagesSlider,
    LiveDetail,
    Preview,
    Detail,
    LivePreview,
    LiveWidget,
    NextEventsWidget,
    ImagesWidget,
    EventsDayWidgetServer,
  },
  data: () => ({}),
  computed: {
    ...mapGetters({
      getLoadingPreview: 'odds/getLoadingPreview',
      getPreview: 'odds/getPreview',
      getEventsDetail: 'odds/getEventsDetail',
      getEventsLiveDetail: 'odds/getEventsLiveDetail',
      getSnackbar: 'settings/getSnackbar',
      getSnackbarText: 'settings/getSnackbarText',
      getLiveMode: 'odds/getLiveMode',
      getCountLive: 'odds/getCountLive',
      getQbet: 'tree/getQbet',
      getSettings: 'cart/getSettings',
      getEventDay: 'settings/getEventDay',
      getNextEvent: 'settings/getNextEvent',
      getLanguage: 'settings/getLanguage',
      getStreamLive: 'settings/getStreamLive',
      getNextEventModuleSelected: 'odds/getNextEventModuleSelected',
      getGameConsole: 'settings/getGameConsole',
      getEnableCentralBanner: 'settings/getEnableCentralBanner',
      getCountNextEvents: 'odds/getCountNextEvents',
      getFeaturedTournamentAutoLoad: 'settings/getFeaturedTournamentAutoLoad',
      getFeaturedTournamentWidget: 'settings/getFeaturedTournamentWidget',
      getRulesSkin: 'rules/getRulesSkin',
      getUseExternalTree: 'uiConfig/useExternalTree',
    }),
  },
  async mounted() {
    //console.log('[DEBUG] MOUNTED CENTER-MOBILE')
    this.fetchSports({ language: this.getLanguage })
    this.loadTournamentWidget()
    // this.openAllFeaturedEvents();
  },
  beforeDestroy() {
    //console.log('[DEBUG] DESTROYED CENTER-MOBILE')
  },
  methods: {
    ...mapActions({
      setSnackbar: 'settings/setSnackbar',
      fetchSports: 'sport/fetchSports',
      fetchFeaturedTournaments: 'settings/fetchFeaturedTournaments',
      setFeaturedTournamentsInfo: 'settings/setFeaturedTournamentsInfo',
      fetchPreview: 'odds/fetchPreview',
    }),

    checkIsMobile() {
      return checkIsMobileDevice()
    },

    closeSnackbar() {
      this.setSnackbar(false)
    },
    async loadTournamentWidget() {
      try {
        const response = await this.fetchFeaturedTournaments()
        if (!response || !response.data || !response.data.featuredTournaments)
          return

        const featuredTournaments = response.data.featuredTournaments
        const translationSkinRules = this.getRulesSkin.filter(
          el => el.type === 'translation'
        )

        if (
          Array.isArray(featuredTournaments) &&
          featuredTournaments.length > 0
        ) {
          for (const tournament of featuredTournaments) {
            const tournamentId = tournament.tournamentId.toString()
            const tournamentTranslations = translationSkinRules.find(
              el => el.source.toString() === tournamentId
            )

            if (tournamentTranslations && tournamentTranslations.detail) {
              const langTranslation = findLodash(
                tournamentTranslations.detail,
                { lang: this.getLanguage }
              )
              if (
                langTranslation &&
                langTranslation.text &&
                langTranslation.text !== ''
              ) {
                tournament.tournamentName = langTranslation.text
              }
            }
          }
        }

        await this.setFeaturedTournamentsInfo(featuredTournaments)
      } catch (error) {
        console.error('Error while loading tournament widget:', error)
      }
    },
  },
}
</script>
